import * as local from './local/products';
import * as nodejs from './nodejs/products';
import * as laravel from './laravel/products';

import { API_DRIVER as DRIVER } from '../config/app';

const api = {
    local,
    nodejs,
    laravel
};

export const { list, get, create, update, remove } = api[DRIVER];
